<template>
  <div class="topRouge" id="reseauxNumerique"  v-if="detailReseauxNumeriqueFilter.length">
    <p class="p_size18 has-text-weight-bold has-text-link bottomVert">
      <b-icon
        icon="circle"
        size="is-small"
        class="circleStyleMobile">
      </b-icon>
      Proposition réseau(x) numérique(s)
    </p>
    <div class="colomn"
      v-for="(reseauxNumerique, index) in detailReseauxNumeriqueFilter"
      :key="index">
      <h3 class="has-text-default has-text-weight-bold topBleu bottomVert">
        {{reseauxNumerique.libelle}}
      </h3>
      <app-carte-reseaux-Numerique :detailReseauxNumerique="reseauxNumerique"
       :markerReseauxNumeriques="markerReseauxNumeriques"/>
      <app-info-reseaux-Numerique :infoReseauxNumerique="reseauxNumerique"/>
    </div>
  </div>
</template>

<script>
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import carteReseauxNumerique from './carteReseauxNumerique';
import infoReseauxNumerique from './infoReseauxNumerique';

export default {
  name: 'index',
  props: ['detailReseauxNumerique', 'adresseReseauxNumeriques'],
  components: {
    appCarteReseauxNumerique: carteReseauxNumerique,
    appInfoReseauxNumerique: infoReseauxNumerique,
  },
  data() {
    return {
      markerReseauxNumeriques: {},
    };
  },
  computed: {
    detailReseauxNumeriqueFilter() {
      return this.detailReseauxNumerique.filter(d => !d.extensionOpportunite.reseauPersoGuid);
    },
  },
  methods: {
    generateMarker() {
      if (this.adresseReseauxNumeriques.lat !== undefined) {
        this.markerReseauxNumeriques = {
          ...this.adresseReseauxNumeriques,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    this.generateMarker();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxNumeriques/index.vue